import _jsx from '@babel/runtime/helpers/jsx';
import React from 'react';
import classNames from 'classnames';
import warning from '@andes/common/build/utils/warning';
var _div, _div2;
const namespace = 'andes-spinner';
const WARNING_COMPONENT = 'This component has been migrated to ProgressIndicatorCircular.';
class Spinner extends React.PureComponent {
  render() {
    warning(false, WARNING_COMPONENT);
    const {
      size = 'large',
      show = true,
      modifier = 'fullscreen',
      className,
      label,
      highlight = false
    } = this.props;
    const classes = classNames(namespace, "".concat(namespace, "--").concat(modifier), highlight && "".concat(namespace, "--highlight"), className);
    const classesIcon = classNames("".concat(namespace, "__icon"), "".concat(namespace, "__icon--").concat(size));
    const classesContainer = classNames("".concat(namespace, "__container"), "".concat(namespace, "__container--").concat(size), !label && "".concat(namespace, "__container--").concat(size, "-notlabel"));
    const classesMask = classNames("".concat(namespace, "__mask"), highlight && "".concat(namespace, "__mask--highlight"));
    return show && /*#__PURE__*/_jsx("div", {
      className: classes
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: classesContainer
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: classesIcon
    }, void 0, _div || (_div = /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__icon-right")
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__icon-border")
    }))), _div2 || (_div2 = /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__icon-left")
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__icon-border")
    })))), /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "__label")
    }, void 0, label)), /*#__PURE__*/_jsx("div", {
      className: classesMask
    }));
  }
}
var Spinner$1 = Spinner;
export { Spinner$1 as default };
